import { render, staticRenderFns } from "./RawMaterialPivotTab.vue?vue&type=template&id=133951d8&"
import script from "./RawMaterialPivotTab.vue?vue&type=script&lang=js&"
export * from "./RawMaterialPivotTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports